import { Component, OnInit, Renderer2, ViewChild, HostListener, inject } from '@angular/core';
import { PlatformService } from './services/platform.service';
import { RegisterIconsService } from './services/register-icons.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MenusService } from './services/menus.service';
import { BuscaService } from './services/busca.service';
import { ApiUsuarioService } from './services/api-usuario.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalFormComponent } from './pages/cliente/modal-form/modal-form.component';
import { ApiS3Service } from './services/api-s3.service';
import { ModalNegocioComponent } from './pages/negocios/modal-negocio/modal-negocio.component';
import { ModalTarefaComponent } from 'src/app/components/tarefa/modal-tarefa/modal-tarefa.component';
import { ExtensaoService } from './services/extensao.service';
import { menuCotacao, menuCotacao_new, menuPrincipal, menuReduzido } from './utils/menus-apice';
import { SobreComponent } from './components/sobre/sobre.component';
import { environment } from 'src/environments/environment';
import { ServiceWorkerService } from './services/service-worker.service';
import { ConnectionService } from 'ng-connection-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { ControllerStatusService } from './services/controller-status.service';
import { ApiInterfaceService } from 'src/app/services/api/api-interface.service';
import { ModalVideoIntroComponent } from './components/modal-video-intro/modal-video-intro.component';
import { TodoControllerService } from './services/todo-controller.service';
import { filter } from 'rxjs/operators';
import { ToolBarActionsService } from 'src/app/services/tool-bar-actions.service';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { pathToRegexp } from 'path-to-regexp';
import { FabButton } from './components/fab-button/fab-button';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
    animations : [
        trigger('animationRotate', [
          state('close', style({ transform: 'rotate(0)' })),
          state('open', style({ transform: 'rotate(-180deg)' })),
          transition('open <=> close', animate('400ms ease-in-out')),
        ]),
        trigger('animationShowHide', [
          state('close', style({ height: '0px', overflow: 'hidden' })),
          state('open', style({ height: '*' })),
          transition('open <=> close', animate('400ms ease-in-out')),
        ])
    ]
})
export class AppComponent implements OnInit {
    @ViewChild('toolBarActions') toolBarActions: any;
    isAdmin: boolean = false;
    isRoot: boolean = false;
    isSuperRoot: boolean = false;
    title = 'Ápice';
    sessao;
    showFabButton: boolean = false;
    validacaoCorretora;
    mostraPeriodoTeste;

    public listaReduzida = menuReduzido;
    public listaMenusCotacao = menuCotacao_new;
    public listaMenuPrincipal = menuPrincipal;

    menusCotacao = this.listaMenusCotacao;
    menuPrincipal = this.listaMenuPrincipal;

    enteredButton = false;
    isMatMenuOpen = false;
    prevButtonTrigger;
    formaPagamento;
    
    menuContraido: boolean = false;
    effectLogo: boolean = false;
    menuToggle: boolean = false;
    autenticado: boolean = false;
    fezCheckStatusSistema: boolean = false;
    callUpdateServicesInfos: boolean = false;
    showAlert: boolean = true;
    internetCaiu = false;
    buscaAtiva: boolean = false;
    recolheItensMenu: boolean = false;
    escondeIconesMenu: boolean = false;
    //mostrar/ocultar filtro
    filtro = {
        open: false,
        page: ''
    };

    version = environment.version;

    public fabButtons: FabButton[] = [
        {
            id: 1,
            icone: 'menu-tarefas',
            titulo: "Nova Tarefa",
            url: '/lista-tarefas',
            open: async (urlPage)=>{
                let url = this.router.url;
                let dialog = await this.dialog.open(ModalTarefaComponent, {
                    data: {tarefa: null, visualizar:false},
                    panelClass: 'modalDefaultP'
                })

                dialog.afterClosed().subscribe(ret=>{
                    if(ret){
                        this.apiUsuario.refreshListaTarefas.next(true);
                    }
                })

                this.gAnalytics.analyticsMonitor('click', 'nova_tarefa', 'Iniciando nova tarefa');
            },
            calcular: false
        },
        {
            id: 2,
            icone: 'business',
            titulo: 'Novo Negócio',
            url: '/funil-de-vendas',
            open: async (urlPage)=>{
                let url = this.router.url;
                let dialog = await this.dialog.open(ModalNegocioComponent, {
                    data: {idFirstItemOportunidades: null, negocio: null},
                    minWidth: 300,
                    minHeight: 300,
                    panelClass: ['modalNegocio', 'novoNegocio']
                })

                dialog.afterClosed().subscribe(ret=>{
                    if(ret == 'atualizar'){                        
                        //console.log('url', url);
                        // if(url != "/funil-de-vendas"){
                        //     this.loadingPage = true;
                        //     this.router.navigate([urlPage]).then(()=>{
                        //         this.loadingPage = false;
                        //     })
                        //     .catch(()=> {this.loadingPage = false;});
                        // }else{
                        //     this.updateNegocio.setUpdateNegocio(true);
                        // }                        
                    }
                })

                this.gAnalytics.analyticsMonitor('click', 'novo_negocio', 'Iniciando novo negócio');
            },
            calcular: false
        },
        {
            id: 3,
            icone: 'account',
            titulo: 'Novo Cliente',
            open: async (urlPage?)=>{
                let widthModal = window.innerWidth;
                let modal = await this.dialog.open(ModalFormComponent, {
                    data: {id: 'novo'},
                    panelClass: 'modalDefaultP',
                    minHeight: 200,
			        minWidth: 250
                })
                modal.afterClosed().subscribe(data=>{
                    // if(data){
                    //     let modalCliente = this.dialog.open(ModalClienteComponent, {
                    //         data: {clienteId: data},
                    //         minHeight: 200,
                    //         panelClass: ['modalDefault']
                    //     })
                    // }
                })

                this.gAnalytics.analyticsMonitor('click', 'novo_cliente', 'Iniciando novo cliente');
            },
            // url: '/cliente-form/novo',
            url: './',
            calcular: false
        },
        {
            id: 4,
            icone: 'hexagon-multiple',
            titulo: "Cotar Diversos",
            children: [
                {
                    id: 41,
                    icone: 'key-chain-variant',
                    titulo: "Aluguel",
                    url: '/cotacao/aluguel/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 42,
                    icone: 'bicycle',
                    titulo: "Bike",
                    url: '/cotacao/bike/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                }
            ]
        },
        {
            id: 5,
            icone: 'heart-pulse',
            titulo: "Cotar Vida",
            children: [
                {
                    id: 51,
                    icone: 'cards-heart',
                    titulo: "Vida Individual",
                    url: '/cotacao/vida/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 52,
                    icone: 'vida-global',
                    titulo: "Vida Global",
                    url: '/cotacao/vida_global/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 53,
                    icone: 'account-injury',
                    titulo: "Acidentes Pessoais",
                    url: '/cotacao/acidentes_pessoais/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 54,
                    icone: 'bag-suitcase',
                    titulo: "Viagem",
                    url: '/cotacao/viagem/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
            ]
        },
        {
            id: 6,
            icone: 'security',
            titulo: "Cotar Compreensivos",
            children: [
                {
                    id: 61,
                    icone: 'home',
                    titulo: "Residencial",
                    url: '/cotacao/residencial/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 62,
                    icone: 'factory',
                    titulo: "Empresarial",
                    url: '/cotacao/empresarial/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                    },
                    calcular: true
                },
                {
                    id: 63,
                    icone: 'domain',
                    titulo: "Condomínio",
                    url: '/cotacao/condominio/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                        // this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_auto', 'Iniciando nova cotação Auto');
                    },
                    calcular: true,
                },
            ]
        },
        {
            id: 7,
            icone: 'car',
            titulo: "Cotar Automóvel",
            showChildren: true,
            children: [
                {
                    id: 71,
                    icone: 'car-hatchback',
                    titulo: "Carro",
                    url: '/cotacao/auto/formulario',
                    open: async (urlPage)=>{
                        // this.loadingPage = true;
                        this.router.navigate([urlPage]).then(()=>{
                            // this.loadingPage = false;
                        })
                        // .catch(()=> {this.loadingPage = false;});
                        this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_auto', 'Iniciando nova cotação Auto');
                    },
                    calcular: true,
                },
                {
                    id: 72,
                    icone: 'truck',
                    titulo: "Caminhão",
                    url: '/cotacao/caminhao/formulario',
                    open: async (urlPage)=>{
                        this.router.navigate([urlPage]).then(()=>{})
                        this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_caminhao', 'Iniciando nova cotação Caminhão');
                    },
                    calcular: true,
                },
                {
                    id: 73,
                    icone: 'motorbike',
                    titulo: "Moto",
                    url: '/cotacao/motocicleta/formulario',
                    open: async (urlPage)=>{
                        this.router.navigate([urlPage]).then(()=>{})
                        this.gAnalytics.analyticsMonitor('click', 'nova_cotacao_motocicleta', 'Iniciando nova cotação Moto');
                    },
                    calcular: true,
                },
            ]
        }
    ]

    iconsMulti = [
        'cards-heart',
        'arrow-left',
        'close',
        'briefcase-edit',
        'barcode',
        'credit-card-outline',
        'bank',
        'cash-usd',
        'file-pdf',
        'search-web',
        'alert-circle-outline',
        'calculator',
        'home',
        'content-copy',
        'content-save',
        'car-info',
        'paperclip',
        'delete',
        'dots-vertical',
        'pencil',
        'file-document-outline',
        'file-document-edit',
        'file-eye',
        'file-multiple',
        'text-box-plus',
        'folder-image',
        'handshake',
        'chevron-left',
        'chevron-right',
        'chevron-down',
        'checkbox-marked-circle',
        'plus',
        'progress-clock',
        'check-circle-outline',
        'swap-horizontal',
        'circle-off-outline',
        'circle-outline',
        'content-save-outline',
        'negocio-fechado',
        'negocio-fechado-home',
        'negocio-perdido',
        'chevron-double-up',
        'negocio-nao-fechado',
        'cash-usd-outline',
        'thumbs-up-down',
        'chevron-double-up',
        'thumb-down-outline',
        'human-male',
        'human-female',
        'cards-heart',
        'factory',
        'phone',
        'whatsapp',
        'email',
        'video',
        'youtube',
        'truck',
        'pdf-box',
        'editando',
        'domain',
        'view-list',
        'view-dashboard',
        'chart-areaspline-variant',
        'tools',
        'exit-to-app',
        'message-question-outline',
        'trash-can-outline',
        'check',
        'clock-outline',
        'robot-confused-outline',
        'cogs',
        'cartao-porto',
        'cartao-porto-black',
        'close-oferta',
        'porto-logo',
        'porto-logo-txt',
        'porto-logo-sem-txt',
        'calendar-sync',
        'vida-global',
        'account-injury',
        'bag-suitcase',
        'heart-pulse',
        'car',
        'security',
        'chevron-up',
		'car-wifi',
		'house-car',
        'bicycle',
        'hexagon-multiple',
        'key-chain-variant',
        'filter',
        'arrow-right-alt'
      ];

    status;
    toolBarActionsConfigs;
    rotaAtual;
	constructor(            
            private apiUsuario: ApiUsuarioService,
		    public apiS3: ApiS3Service,
            private router: Router,
            private api: ApiInterfaceService,
			public platformService: PlatformService,
            public icons: RegisterIconsService,
            private menusService: MenusService,
            private buscaService: BuscaService,
            public extensaoService: ExtensaoService,
            private gAnalytics: GAnalyticsService,
            private dialog: MatDialog,
            public snackBar: MatSnackBar,
            public sw: ServiceWorkerService,
            public controllerStatus: ControllerStatusService,
            private connectionService: ConnectionService,
            public todoController: TodoControllerService,
            private ren: Renderer2,
            private toolBarActionsService: ToolBarActionsService
		) {
			icons.registerIcons(['backup-restore','menu', 'monitor-dashboard', 'account-group', 'business', 'menu-tarefas', 'account', 'swap-horizontal',
			'calculator', 'office-building', 'cog', 'lifebuoy', 'plus', 'briefcase', 'credit-card-multiple', 'alert-octagram',
			'logout-variant', 'funnel', 'cash-multiple', 'calendar-text-outline', 'tune', 'file-download-outline', 'wrench',
		    'file-document', 'account-multiple', 'city', 'source-branch', 'format-list-checks', 'motorbike', 'car-hatchback','information-outline', 'close', 'currency-usd-off','corretor_digital2', 'domain','tag', 'porto-seguro', 'itau', ...this.iconsMulti]);

            this.connectionService.monitor().subscribe(currentState => {
                if(!currentState.hasInternetAccess && !currentState.hasNetworkConnection) {
                    this.snackBar.open('Sem conexão!', 'Ok', {duration: 6000});
                    this.internetCaiu = true;
                }
                else if (this.internetCaiu) {
                    this.snackBar.open('Conectado novamente!', 'Ok', {duration: 6000});
                    this.internetCaiu = false;
                }
                this.status = !!status;
              });
            
        }
    
    manterChat: boolean = false;
    ngOnInit(){
        this.apiUsuario.atualizaKeysPagamento();  
        this.controllerStatus.getJsonPlanos(); 
        this.controllerStatus.getJsonLinksVideos(); 
        //observa mudanças de abertura/fechamento no menu mobile
        this.menusService.toggleMenu().subscribe(ret => {
            this.menuToggle = ret
            if(this.menuToggle) this.filtro.open = false;
        });
        //observa mudança se usuário esta autenticado ou não no sistema
        this.apiUsuario.autenticado.asObservable().subscribe(ret=> {
            this.autenticado = ret
            if(this.autenticado){
                if(this.apiUsuario.getCredenciais().admin) {
                    this.isAdmin = true;
                    if (this.apiUsuario.getCredenciais().root == 3) {
                        this.isSuperRoot = true;
                        this.isRoot = true;
                    } else if (this.apiUsuario.getCredenciais().root) {
                        this.isRoot = true;
                    }
                    this.menuPrincipal = this.listaMenuPrincipal;
                    this.menusCotacao = this.listaMenusCotacao;
                }else{
                    this.isAdmin = false;
                }
                this.sessao = this.apiUsuario.getCredenciais();
                this.toolBarActionsConfigs = this.toolBarActionsService.getToolBarActionsConfigs(this.isAdmin);
                    this.validacaoCorretora = this.apiUsuario.verificaLicenca();
                if (this.validacaoCorretora?.prazoHoras < 0) {
                    this.menuPrincipal = this.listaReduzida;
                    this.menusCotacao = [];
                }
                this.mostraPeriodoTeste = true;    

                if(!this.callUpdateServicesInfos){                    
                    this.callUpdateServicesInfos = true;
                    //** BUSCA INFORMAÇÕES DE STATUS DAS SEGURADORAS */
                    // this.api.getServicesInfos();
               }
               
                //console.log('fezCheck', this.fezCheckStatusSistema);
                //se autenticado faz 1-uma verificação do check status de pagamento
                if(!this.fezCheckStatusSistema){
                    this.fezCheckStatusSistema = true;
                    this.controllerStatus.buscaSeguradoras();                    
                    
                        this.fazCheckStatusSistema();                     
                    
                    setTimeout(()=>{
                        this.openVideoIntro();
                    },1500)

                    let count = 0;
                    let interval2 = setInterval(()=> {
                        this.atualizaStatusExtensao();
                        this.verificaRecolheItensMenu();
                        count++;
                        if(count > 120000 || this.extensaoInstalada){
                            clearInterval(interval2);
                        }

                    }, 100);                   
                }
                
            }else{
                this.mostraPeriodoTeste = false;
            }     
        });

        this.menusService.menuFilter().subscribe(ret => {
            this.filtro.open = ret.open;
            this.filtro.page = ret.page;        
            if(this.filtro.open) this.closeMenuToggle();  
        });

        this.menusService.buscaAberta.subscribe(ret => {
            this.atualizaBuscaAberta(ret);
        });

        this.toolBarActionsService.setaTituloEmitter.subscribe(novoTitulo => {
            if(novoTitulo) this.setaTituloPaginaAtual(novoTitulo);
        });

        this.verificaRecolheItensMenu();

        this.menusService.hiddenButton().subscribe(ret=> this.showFabButton = ret);
        
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            let url = this.router.routerState.snapshot.url
            this.rotaAtual = url;
            this.menuContraido = false;
            this.showAlert = true;
            this.atualizaBuscaAberta(false);
            this.buscaService.enviaFecharBusca(this.buscaAtiva);
            this.menusService.setMenuDesktop(this.menuContraido);      
            this.setaMenuComoAtivo();
            if(this.toolBarActions) this.toolBarActions.ngOnInit();
            let invervalCheca;
            let count = 0;
            let minimizado:any = document.getElementsByClassName('minimized');
            if (minimizado.length) {
                this.manterChat = false;
            } else {
                this.manterChat = true;
            }

            if(this.autenticado && this.platformService.virtualDeviceType == 'desktop' && this.manterChat || url == "/suporte" && this.autenticado){
                invervalCheca = setInterval(()=>{
                    let elemChat:any = document.querySelector('#md-app-widget');
                    if(elemChat){
                        clearInterval(invervalCheca);
                        let styles = elemChat.attributes.style.value;                                                
                        if(/hidden/gm.test(styles)) {
                            elemChat.attributes.style.value = elemChat.attributes.style.value.replace('hidden', 'visible');
                        }else{
                            elemChat.attributes.style.value = "visibility: visible;";
                        }      
                        
                        if(this.manterChat && url != "/suporte") {
                            let divChat:any = document.getElementsByClassName('RightSide');
                            let styles = divChat[0]?.attributes?.style?.value;

                            if(styles){
                                divChat[0].attributes.style.value = styles + "right: 75px; margin-bottom: 10px;";
                            }
                        }
                    }
                    count++;
                    if(count > 100){
                        clearInterval(invervalCheca);
                    }
                },500);
            }else if(url == "/suporte" && this.autenticado && this.platformService.virtualDeviceType != 'desktop'){    
                invervalCheca = setInterval(()=>{
                    let elemChat:any = document.querySelector('#md-app-widget');
                    
                    if(elemChat){
                        clearInterval(invervalCheca);
                        let styles = elemChat.attributes.style.value;                                                
                        if(/hidden/gm.test(styles)) {
                            elemChat.attributes.style.value = elemChat.attributes.style.value.replace('hidden', 'visible');
                        }else{
                            elemChat.attributes.style.value = "visibility: visible;";
                        }                        
                    }
                    count++;
                    if(count > 100){
                        clearInterval(invervalCheca);
                    }
                },10);
            }else {
                invervalCheca = setInterval(()=>{
                    let elemChat:any = document.querySelector('#md-app-widget');
                    if(elemChat){
                        clearInterval(invervalCheca);
                        let styles = elemChat.attributes.style.value;                        
                        if(/visible/gm.test(styles)) {
                            elemChat.attributes.style.value = elemChat.attributes.style.value.replace('visible', 'hidden');
                        }else if(!/visibility/gm.test(styles)){
                            elemChat.attributes.style.value = "visibility: hidden;";
                        }
                    }
                    count++;
                    if(count > 100){
                        clearInterval(invervalCheca);
                    }
                },10);                  
            }
        });
        this.router.events.pipe(
            filter(event => event instanceof NavigationStart)
        ).subscribe((data:any) => { 
            if(data.url != '/login' && !/\/redefinir-senha/g.test(data.url) && !/\/criar-senha/g.test(data.url)
            && data.url != '/recuperar-senha' && data.url != '/criar-conta' && data.url != '/confirmacao'
            && data.url != '/ens'
            ){
                this.apiUsuario.pathHistory = data.url;
            }
        });
        /**
         * Chama service-work para verificar novos builds
         */
        setTimeout(()=>{
            this.sw.checkUpdate();              
        },60000)

    }

    async fazCheckStatusSistema(){
        await this.controllerStatus.checkStatusPagamento(true);
        if (this.controllerStatus.assinaturaAntiga) {
            await this.controllerStatus.checkStatusPagamento(true);
        }
    }

    // checkCorretoraVencendo() {
    //     let assinaturaFutura = this.sessao?.assinaturaId.filter(ass => ass.situacao == 2)
    //     let assinaturaAtual = this.sessao?.assinaturaId.filter(ass => ass.situacao == 1)
    //     if (this.sessao?.assinaturaId && !assinaturaFutura) {
    //         return false;
    //     } else if (this.sessao?.assinaturaId.length > 0) {

    //         return true;
    //     }
    //     return false;
    // }

    abrirPerfil() {
        this.router.navigateByUrl('/perfil-usuario');
        this.closeMenuToggle();
    }

    extensaoInstalada: boolean = false;
    timeOutExtensao;
    atualizaStatusExtensao(){       
        let input:any = document.querySelector('#bExtensaoExterno');
        clearTimeout(this.timeOutExtensao);
        if(input && input.value == 'mudei'){
            console.log('##extension');
            this.extensaoInstalada = true;
            this.extensaoService.setStatusExtensao(true);
            this.todoController.extensaoInstalada = true;
            this.timeOutExtensao = setTimeout(()=>{              
                this.todoController.verificarToDo('extensao');
            },1000)
        }
    }
    
    //controller menu
    alternaMenu() {
        this.menuContraido = !this.menuContraido;
        this.effectLogo = !this.menuContraido;
        if(this.platformService.virtualDeviceType == 'desktop'){
            this.menusService.setMenuDesktop(this.menuContraido);
        }
    }

    //fecha menu mobile backdrop
    closeMenuToggle(){
        this.menuToggle = false;
        this.menusService.setToggleMenu(false);
    }

    //navega para a rota e também deixa a opção do menu ativa
    rotaLinkMenu(rota, index, j?) {
        if (rota) {
            if (rota === '/corretor-digital' && this.platformService.deviceType != 'desktop') {
                return this.snackBar.open('Painel do Corretor Digital ainda não disponível para dispositivos móveis.', 'Ok', { duration: 6000 });
            }
            if (this.menuPrincipal[index].subList.length > 0) {
                for (let [s, sub] of Object.entries(this.menuPrincipal[index].subList)) {
                    if (j == s) {
                        this.menuPrincipal[index].subList[j].active = !sub.active;
                    } else {
                        this.menuPrincipal[index].subList[s].active = false;
                    }
                }
                for (let i = 0; i < this.menuPrincipal.length; i++) { if (this.menuPrincipal[i].active) { this.menuPrincipal[i].active = false; } }
                this.menuPrincipal[index].open = false;
                this.menuPrincipal[index].active = true;
            } else {
                for (let [m, menu] of Object.entries(this.menuPrincipal)) {
                    if (m == index) {
                        this.menuPrincipal[index].active = !menu.active;
                    } else {
                        this.menuPrincipal[m].active = false;
                    }
                    if (menu.subList.length > 0) { for (let i = 0; i < menu.subList.length; i++) { menu.subList[i].active = false; } }
                }

            }

            if (this.menuPrincipal[index]?.external) {
                window.open(rota, '_blank');
            } else {
                this.router.navigateByUrl(rota).finally(() => {
                    if (this.platformService.virtualDeviceType == 'phone' || this.platformService.virtualDeviceType == 'tablet') {
                        this.closeMenuToggle();
                    }
                })
            }
            // this.apiS3.setStateMenuPerfil(false);
        }
    }
    
    openVideoIntro(){
        if(!localStorage.getItem('AGGILIZADOR-VIDEO') && this.autenticado){
            let dialog = this.dialog.open(ModalVideoIntroComponent, {
                panelClass: 'modal-video-intro'
            });
        }        
    }
    
    //abre opções do menu
    toggleSubMenu(index) {
        for (let [i, menu] of Object.entries(this.menuPrincipal)) {
            if (index == i) {
                this.menuPrincipal[index].open = !menu.open
            } else {
                this.menuPrincipal[i].open = false
            }
        }

        for (let i = 0; i < this.menuPrincipal.length; i++) {
            if (this.menuPrincipal[i].subList.length > 0) {
                for (let j = 0; j < this.menuPrincipal[i].subList.length; j++) {
                    if (this.router.url == this.menuPrincipal[i].subList[j].url) {
                        this.menuPrincipal[i].subList[j].active = true;
                    } else {
                        this.menuPrincipal[i].subList[j].active = false;
                    }
                }
            }
        }

    }

    async loadAvatar(){
		if(!this.apiUsuario.avatar){
			this.apiUsuario.avatar = await this.apiS3.loadAvatarUsuarioLogado();
		}
    }
    
    esconderPeriodo() {
        let divPeriodoTest = document.querySelector('.periodoTeste');
        divPeriodoTest.classList.add('periodoHidden');
        this.mostraPeriodoTeste = false;
    }

    openAbout(){
		let dialog = this.dialog.open(SobreComponent, {
			panelClass: 'modalDefault'
		});
    }
    
    contratar() {
        this.router.navigateByUrl('/contratar');
        this.closeMenuToggle();
    }

    verPix() {
        this.router.navigateByUrl('/contratar');
        this.controllerStatus.renovacao = true;
        this.closeMenuToggle();
    }

    observaRota() {
      this.router.events.forEach(e => {
        if(e instanceof NavigationEnd) {
        //   console.log('-> ->',e.url);
          return e.url
        }
      });  
    }

    menuEnter() {
        this.isMatMenuOpen = true;
    }

    menuLeave(trigger, button) {
        setTimeout(() => {
            if (!this.enteredButton) {
                this.isMatMenuOpen = false;
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.isMatMenuOpen = false;
            }
        }, 80)
    }

    buttonEnter(trigger) {
        setTimeout(() => {
            if (this.prevButtonTrigger && this.prevButtonTrigger != trigger) {
                this.prevButtonTrigger.closeMenu();
                this.prevButtonTrigger = trigger;
                trigger.openMenu();
            }
            else if (!this.isMatMenuOpen) {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger
                trigger.openMenu()
            }
            else {
                this.enteredButton = true;
                this.prevButtonTrigger = trigger
            }
        })
    }

    changeStyle(menu) {
        menu.hovered = !menu.hovered;
    }

    buttonLeave(trigger, button) {
        setTimeout(() => {
            if (this.enteredButton && !this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } if (!this.isMatMenuOpen) {
                trigger.closeMenu();
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(button['_elementRef'].nativeElement, 'cdk-program-focused');
            } else {
                this.enteredButton = false;
            }
        }, 100)
    }

    setaMenuComoAtivo() {
        try {
            this.menuPrincipal.forEach(m => m.active = false);
            let menu = this.menuPrincipal.find(m => m.url === this.router.routerState.snapshot.url);
            if(menu) menu.active = true;
            else {
                this.menuPrincipal.forEach(m => {
                    let subMenu = m.subList.find(s => s.url === this.router.routerState.snapshot.url);
                    if(subMenu) m.active = true;
                });
            }
        } catch (error) {
            return false;
        }
    }

    goToCotacoes() {
        this.router.navigateByUrl('/cotacoes');
    }

    logout() {	
		this.apiS3.avatarUsuarioLogado = null;
		this.apiUsuario.avatar = null;
		this.router.navigateByUrl('/login');
        this.closeMenuToggle();
		localStorage.setItem('pathRefer', '');
	}

    encontraTitulo() {
        try {
            if (this.rotaAtual) {
                let rota = this.encontraRota(this.rotaAtual);
                return this.toolBarActionsConfigs[rota]?.titulo ? this.toolBarActionsConfigs[rota].titulo : '';
            } else {
                return '';
            }
        } catch (error) {
            return '';
        }
    }

    encontraRota(rotaAtual){
        return Object.keys(this.toolBarActionsConfigs).find((info) => this.verificaURL(rotaAtual, info));
    }

    atualizaBuscaAberta(ativa) {
        this.buscaAtiva = ativa;
        this.verificaRecolheItensMenu();
    }

    verificaURL(urlAtual, padrao) {
        try {
          if(padrao.includes('?')) {
            if(urlAtual.includes('?')) {
              return padrao.split('?')[0] === urlAtual.split('?')[0];
            } else {
              return false;
            }
          } else {
            const regexPattern = pathToRegexp(padrao);
            const correspondem = regexPattern.test(urlAtual);
            return correspondem;
          }
        } catch (error) {
          return false;
        }
      }

    @HostListener('window:resize', ['$event'])
    onResize(){
        this.verificaRecolheItensMenu();
    }

    verificaRecolheItensMenu() {
        this.escondeIconesMenu = false;
        if(this.platformService.size.width <= 575) {
            this.recolheItensMenu = this.buscaAtiva ? true : false;
        } else if(this.platformService.size.width <= 991) {
            this.recolheItensMenu = false;
        } else if(this.platformService.size.width <= 1165) {
            this.recolheItensMenu = true;
            this.escondeIconesMenu = this.buscaAtiva ? true : false;
        } else if(this.platformService.size.width <= 1300) {
            this.recolheItensMenu = this.extensaoInstalada  ? false : true;
        } else {
            this.recolheItensMenu = this.buscaAtiva ? true : false;
        }
    }

    setaTituloPaginaAtual(novoTitulo) {
        try {
            let rota = this.encontraRota(this.rotaAtual);
            if(rota) this.toolBarActionsConfigs[rota].titulo = novoTitulo;
        } catch (error) {
            return false;
        }
    }
}
